import { KYMW0900Model } from '../kymw0900.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 画像作成指示画面　画像作成指示を更新するサービス
 *
 * @export ClearPlanGoodsChangeManageService
 * @class ClearPlanGoodsChangeManageService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class ClearPlanGoodsChangeManageService extends PlessJsonResponderSub<any> {

  /**
   * 処理に使用するModel
   *
   * @private
   * @type {KYMW0C00Model}
   * @memberof ClearPlanGoodsChangeManageService
   */
  private model: KYMW0900Model;

  /**
   * API成功時後続処理
   *
   * @private
   * @type {Function}
   * @memberof ClearPlanGoodsChangeManageService
   */
  private successFunc: Function;

  vo = {
    orderCode: '',
    pCode: '',
  };

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof ClearPlanGoodsChangeManageService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        OrderCode: this.vo.orderCode,
        PCode: this.vo.pCode
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @param {Function} successFunc 成功時後続処理
   * @memberof ClearPlanGoodsChangeManageService
   */
  execute(model: any, vo: any, successFunc: Function = null): void {
    this.model = model;
    this.vo.orderCode = vo.orderCode;
    this.vo.pCode = vo.pCode;
    this.successFunc = successFunc;
    this.send('clearPlanGoodsChangeManage', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof ClearPlanGoodsChangeManageService
   */
  success(data: any): void {
    if (this.successFunc !== null) {
      this.successFunc();
    }
  }
}
